import { TDirectorMessage } from '../../../../types/partner-page-types';
import { If } from '../../../Atoms/Conditionals';

interface IDirectorMessage {
  directorMessage: TDirectorMessage;
}
export const DirectorMessage: React.FC<IDirectorMessage> = ({
  directorMessage,
}) => {
  if (!directorMessage.active) return <></>;
  const lhsWidth = directorMessage.icon ? 'w-1/3' : 'w-1/4';
  const rhsWidth = directorMessage.icon ? 'w-2/3' : 'w-3/4';
  return (
    <div className="wg-container pb-28 sm:-mx-5 sm:pb-14">
      <div className="directorMessage flex items-center bg-white rounded-sm border-sm border-blue-100 sm:flex-col sm:rounded-none">
        <div
          className={`${lhsWidth} flex items-center justify-start pl-20 sm:justify-start sm:w-11/12 sm:pl-12 sm:py-4 sm:border-blue-100 sm:border-b-sm`}
        >
          <If condition={!!directorMessage.icon}>
            <img
              className="w-14 h-14 object-contain"
              src={directorMessage.icon}
              alt="icon"
            ></img>
          </If>
          <div className="border-r-sm border-blue-100 px-4 w-full sm:border-r-0 sm:pr-1">
            <p className="text-s-20 font-bold text-font-500">
              {directorMessage.name}
            </p>
            <p className="text-base text-[#596c85] font-medium">
              {directorMessage.designation}
            </p>
          </div>
        </div>
        <p
          className={`${rhsWidth} p-4 text-base text-font-500 font-medium sm:w-full sm:text-s-14 sm:px-5`}
        >
          {directorMessage.message}
        </p>
      </div>
    </div>
  );
};
